import * as React from 'react'
import { ReactNode } from 'react'
import { AuthProvider as ReactOidcAuthProvider, useAuth } from 'react-oidc-context'
import {
  clearFailedCallbackFromUrl,
  onSigninCallback,
  resetFailedCallbackGuard,
  userManager,
} from './config'

type Props = {
  children: ReactNode
}

/**
 * react-oidc-context czyści adres z ?code=&state= wyłącznie po udanym
 * logowaniu (onSigninCallback). Po nieudanym zostają w URL-u, więc każde
 * odświeżenie odtwarza ten sam błąd — stąd "teraz zawsze mam taki ekran".
 * Zdejmujemy je (raz na kartę), żeby odświeżenie startowało czyste logowanie.
 */
const FailedCallbackUrlCleanup = () => {
  const { error, isAuthenticated } = useAuth()

  React.useEffect(() => {
    if (isAuthenticated) resetFailedCallbackGuard()
    else if (error) clearFailedCallbackFromUrl()
  }, [error, isAuthenticated])

  return null
}

export const AuthProvider = ({ children }: Props) => (
  <ReactOidcAuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
    <FailedCallbackUrlCleanup />
    {children}
  </ReactOidcAuthProvider>
)
